import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const MedalStarSolidIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="48"
			height="48"
			viewBox="0 0 48 48"
			fill="none"
			{...props}
		>
			<path
				d="M38 18C38 20.9 37.14 23.56 35.66 25.78C33.5 28.98 30.08 31.24 26.1 31.82C25.42 31.94 24.72 32 24 32C23.28 32 22.58 31.94 21.9 31.82C17.92 31.24 14.5 28.98 12.34 25.78C10.86 23.56 10 20.9 10 18C10 10.26 16.26 4 24 4C31.74 4 38 10.26 38 18Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M42.4999 36.9398L39.1999 37.7198C38.4599 37.8998 37.8799 38.4598 37.7199 39.1998L37.0199 42.1398C36.6399 43.7398 34.5999 44.2198 33.5399 42.9598L23.9999 31.9998L14.4599 42.9798C13.3999 44.2398 11.3599 43.7598 10.9799 42.1598L10.2799 39.2198C10.0999 38.4798 9.51991 37.8998 8.79991 37.7398L5.49991 36.9598C3.97991 36.5998 3.43991 34.6998 4.53991 33.5998L12.3399 25.7998C14.4999 28.9998 17.9199 31.2598 21.8999 31.8398C22.5799 31.9598 23.2799 32.0198 23.9999 32.0198C24.7199 32.0198 25.4199 31.9598 26.0999 31.8398C30.0799 31.2598 33.4999 28.9998 35.6599 25.7998L43.4599 33.5998C44.5599 34.6798 44.0199 36.5798 42.4999 36.9398Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.1599 11.96L26.3399 14.32C26.4999 14.64 26.9199 14.96 27.2999 15.02L29.4399 15.38C30.7999 15.6 31.1199 16.6 30.1399 17.58L28.4799 19.24C28.1999 19.52 28.0399 20.06 28.1399 20.46L28.6199 22.52C28.9999 24.14 28.1399 24.78 26.6999 23.92L24.6999 22.74C24.3399 22.52 23.7399 22.52 23.3799 22.74L21.3799 23.92C19.9399 24.76 19.0799 24.14 19.4599 22.52L19.9399 20.46C20.0199 20.08 19.8799 19.52 19.5999 19.24L17.9399 17.58C16.9599 16.6 17.2799 15.62 18.6399 15.38L20.7799 15.02C21.1399 14.96 21.5599 14.64 21.7199 14.32L22.8999 11.96C23.4799 10.68 24.5199 10.68 25.1599 11.96Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(MedalStarSolidIcon);
